import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';
import TransactionDetailsItem from '../transaction-details-item/transaction-details-item.component';
import { DateTime } from 'luxon';
import { Transaction } from 'api/transactions/transactions.types';

const TransactionInformation = ({
  extTxId,
  checks,
  source,
  openedDate,
  total,
}: Transaction) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="TransactionDetailsDrawer.TransactionInformation">
      <Typography
        variant="h3"
        mb={2}
        data-testid="TransactionDetailsDrawer.TransactionInformation.Title"
      >
        {t('drawer.transactionDetailsDrawer.transactionInfo.title')}
      </Typography>

      <Typography
        mb={1}
        sx={{ fontWeight: 'bold' }}
        data-testid="TransactionDetailsDrawer.TransactionInformation.ExtTxID.Label"
      >
        {t(
          'drawer.transactionDetailsDrawer.transactionInfo.externalTxId.label',
        )}
      </Typography>

      <Typography data-testid="TransactionDetailsDrawer.TransactionInformation.ExtTxID.Value">
        {extTxId}
      </Typography>

      <Grid container spacing={2} mt={1}>
        <TransactionDetailsItem
          property="TransactionInformation.Source"
          value={source}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.source.label',
          )}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Checks"
          value={checks?.length?.toString()}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.checks.label',
          )}
        />
      </Grid>

      <Typography
        mb={1}
        mt={2}
        sx={{ fontWeight: 'bold' }}
        data-testid="TransactionDetailsDrawer.TransactionInformation.CheckID.Label"
      >
        {t('drawer.transactionDetailsDrawer.transactionInfo.checkId.label')}
      </Typography>

      <Typography data-testid="TransactionDetailsDrawer.TransactionInformation.CheckID.Value">
        {checks?.length > 0 ? checks[0].checkId : ''}
      </Typography>

      <Grid container spacing={2} mt={1}>
        <TransactionDetailsItem
          property="TransactionInformation.OpenDate"
          value={DateTime.fromISO(openedDate).toLocaleString()}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.openDate.label',
          )}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Discount"
          value={formatCurrency(total?.dicountTotal)}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.discount.label',
          )}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Subtotal"
          value={formatCurrency(total?.subTotal)}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.subtotal.label',
          )}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Tax"
          value={formatCurrency(total?.tax)}
          label={t('drawer.transactionDetailsDrawer.transactionInfo.tax.label')}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Tip"
          value={formatCurrency(total?.gratuity ?? 0)}
          label={t('drawer.transactionDetailsDrawer.transactionInfo.tip.label')}
        />
        <TransactionDetailsItem
          property="TransactionInformation.Total"
          value={formatCurrency(total?.total)}
          label={t(
            'drawer.transactionDetailsDrawer.transactionInfo.total.label',
          )}
        />
      </Grid>
    </Box>
  );
};

export default TransactionInformation;
